import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19b7cb91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yuyan" }, null, -1))
const _hoisted_5 = { class: "headerText localText" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon_down_arrow icon-houyigeyouzineirong" }, null, -1))
const _hoisted_7 = {
  ref: "refAppDownloadUrl",
  id: "appDownloadUrl",
  alt: "app download url"
}
const _hoisted_8 = { class: "headerText downLoadText" }
const _hoisted_9 = { class: "bodyWrapper" }
const _hoisted_10 = { class: "rightWrapper" }
const _hoisted_11 = {
  key: 0,
  class: "signInText"
}
const _hoisted_12 = {
  key: 1,
  class: "signInText"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emptyPopoverView" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-youxiang" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-mima" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-diqiu" }, null, -1))
const _hoisted_17 = { class: "passwordText" }
const _hoisted_18 = { class: "createAccountText" }
const _hoisted_19 = { class: "footer" }
const _hoisted_20 = { class: "copyRightText" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 0,
  class: "separator"
}
const _hoisted_24 = ["href"]

import {
  computed,
  onMounted,
  reactive,
  ref, watch,
  unref,
} from 'vue';
import axios from 'axios';
import moment from 'moment';
import {transformI18n, i18n} from '@/langs/i18n';
import QRCode from 'qrcode';
import type {FormInstance} from 'element-plus';
import {ElMessage, FormRules} from 'element-plus';
import {useRouter} from 'vue-router';
import {useUserStore} from '@/stores/user';
import {useSettingStore} from '@/stores/setting';
import {userLogin} from '@/api/user';
import {dataCenterList} from '@/api/dataCenter';
import {sysCfgGet} from '@/api/sysCfg';
import {isEmail} from '@/utils';
import {getCountryObj} from '@/utils/countryList';
import ScanLogin from './components/scanLogin';

type VoidNoop = (arg0?: Error) => void

interface stateType {
  username: string
  password: string,
  country: string,
  isRememberPwd: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useUserStore();
const settingStore = useSettingStore();
const router = useRouter();
const lang = computed(() => settingStore.lang);
const dataCenter = ref({});
const dataCenterCountry = ref({});
const loginLogo = ref('');
const webSiteObj = ref({});
const companyInfo = ref({});
const sysNameVal = ref('');

const nowYear = computed(() => moment().format('YYYY'));

const companyName = computed(() => {
  const local = i18n.global.locale.value;
  if (local === 'zh' || local === 'zh-cn') {
    return unref(companyInfo).company_zh || '';
  }
  return unref(companyInfo).company_en || '';
});

const aboutUsUrl = computed(() => {
  const local = i18n.global.locale.value;
  if (local === 'zh' || local === 'zh-cn') {
    return unref(webSiteObj).zh || '';
  }
  return unref(webSiteObj).en || '';
});

const termsOfUsePrivacyPolicyUrl = computed(() => {
  const local = i18n.global.locale.value;
  const baseURL = settingStore.hostUrl || `${window.location.origin}/`;
  if (local === 'zh' || local === 'zh-cn') {
    return `${baseURL}link/zh/privacy-policy.html`;
  }
  return `${baseURL}link/en/privacy-policy.html`;
});

const defaultCountryObj = computed(() => {
  const local: string = settingStore.lang;
  let language = 'en';
  if (local === 'zh' || local === 'zh-cn') {
    language = 'zh';
  }
  return getCountryObj(language);
});

watch(() => settingStore.lang, (newValue) => {
  if (newValue) {
    initDownloadQrCode();
  }
});

onMounted(() => {
  initDownloadQrCode();
  getDataCenterList();
  getSysCfg();
});

const initDownloadQrCode = () => {
  const opts = {
    errorCorrectionLevel: 'H',
    type: 'image/jpeg',
    quality: 1,
    margin: 2,
  };
  const local = i18n.global.locale.value;
  let appDownloadUrl;
  if (local === 'zh' || local === 'zh-cn') {
    // eslint-disable-next-line
    appDownloadUrl = window.location.origin + '/appDownload.html?lang=zh';
    // 'https://d.solar.eonlandfuture.com/link/cn/index.html';
  } else {
    // eslint-disable-next-line
    appDownloadUrl = window.location.origin + '/appDownload.html';
    // 'https://d.solar.eonlandfuture.com/link/en/index.html';
  }
  QRCode.toDataURL(appDownloadUrl, opts, (err, url) => {
    document.getElementById('appDownloadUrl').src = url;
  });
};

const getDataCenterList = async () => {
  try {
    const res = await dataCenterList({
    });
    dataCenter.value = res.data?.data?.dataCenter || {};
    dataCenterCountry.value = res.data?.data?.dataCenter_country || {};
  } catch {
    // do nothing.
  }
};

const getSysCfg = async () => {
  try {
    const res = await sysCfgGet();
    companyInfo.value = res.data.data?.info || {};
    loginLogo.value = res.data.data?.picture?.loginLogo;
    webSiteObj.value = res.data.data?.webSite || {};
    const sysName = res.data.data?.sysName || '';
    document.title = sysName;
    settingStore.setSysName(sysName);
    sysNameVal.value = sysName;
  } catch {
    // do nothing.
  }
};

const loading = ref(false);
const ruleFormRef = ref<FormInstance>();
const isEmailLogin = ref(true);
const scanPopoverVisible = ref(false);
const isShowBigChar = ref(false);

const popoverContent = computed(() => {
  if (isEmailLogin.value) {
    return transformI18n('login.scanLogin');
  }
  return transformI18n('login.emailLogin');
});

const form = reactive<stateType>({
  username: '',
  password: '',
  country: '',
  isRememberPwd: false,
});

const validateName = (rule: any, value: string, callback: VoidNoop) => {
  if (value === '') {
    callback(new Error(transformI18n('login.emailReg')));
    return;
  }
  if (!isEmail(value)) {
    callback(new Error(transformI18n('login.emailCorrectReg')));
    return;
  }
  callback();
};

const rules = computed(() => reactive<FormRules>({
  username: [{
    required: true,
    validator: validateName,
    trigger: 'change',
  }],
  password: [{
    required: true,
    message: transformI18n('login.passwordReg'),
    trigger: 'change',
  }],
  country: [{
    required: false,
    message: transformI18n('login.countryReg'),
    trigger: 'change',
  }],
}));

const enterUserName = () => {
  handleLogin();
};

const handleLogin = () => {
  ruleFormRef.value?.validate((valid?: boolean) => {
    if (valid) {
      login();
    }
  });
};

const handleCommand = (command: string) => {
  i18n.global.locale.value = command;
  settingStore.setLang(command);
};

const login = async () => {
  const {
    country,
  } = form;
  const continent = defaultCountryObj.value[country]?.continent;
  const hostUrl = dataCenterCountry.value[country.toLocaleLowerCase()] || dataCenter.value[continent] || '';
  axios.defaults.baseURL = hostUrl;
  settingStore.setHostUrl(hostUrl);
  loading.value = true;
  try {
    const res = await userLogin({
      username: form.username,
      password: form.password,
      forceOperate: false,
    });
    const {data} = res.data;
    loginSuccess({ serverUrl: null, token: data.token });
  } catch (e) {
    // do nothing.
  } finally {
    loading.value = false;
  }
};

const loginSuccess = ({ serverUrl, token }) => {
  if (serverUrl) {
    const hostUrl = serverUrl;
    axios.defaults.baseURL = hostUrl;
    settingStore.setHostUrl(hostUrl);
  }
  store.setToken(token);
  ElMessage.success(transformI18n('login.loginSuccess'));
  router.push('/');
};

const passwordKeyPress = (event) => {
  const e = event || window.event;
  const keyCode = e.keyCode || e.which;
  const isShift = e.shiftKey || keyCode === 16 || false;
  if (((keyCode >= 65 && keyCode <= 90) && !isShift)
    || ((keyCode >= 97 && keyCode <= 122) && isShift)) {
    isShowBigChar.value = true;
  } else {
    isShowBigChar.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (loginLogo.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: loginLogo.value,
              class: "logo",
              alt: "logo"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_dropdown, {
          onCommand: handleCommand,
          placement: "bottom",
          trigger: "hover"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  class: _normalizeClass({'is-active': _unref(lang) === 'zh'}),
                  command: "zh"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('language.chinese')), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_el_dropdown_item, {
                  class: _normalizeClass({'is-active': _unref(lang) === 'en'}),
                  command: "en"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('language.english')), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('language.local')), 1),
              _hoisted_6
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 180,
          trigger: "hover",
          popperStyle: "padding: 0"
        }, {
          reference: _withCtx(() => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('login.appDownload')), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("img", _hoisted_7, null, 512)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (isEmailLogin.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('login.signIn')), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('login.scanLogin')), 1)),
        _createVNode(_component_el_popover, {
          visible: scanPopoverVisible.value,
          content: _unref(popoverContent),
          placement: "left",
          "popper-class": "scanPopover"
        }, {
          reference: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["visible", "content"]),
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isEmailLogin.value = !isEmailLogin.value)),
          onKeydown: _cache[1] || (_cache[1] = ($event: any) => (isEmailLogin.value = !isEmailLogin.value)),
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (scanPopoverVisible.value = true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (scanPopoverVisible.value = false)),
          onFocusin: _cache[4] || (_cache[4] = ($event: any) => (scanPopoverVisible.value = true)),
          onFocusout: _cache[5] || (_cache[5] = ($event: any) => (scanPopoverVisible.value = false)),
          class: _normalizeClass(["loginImage", {scanLoginImage: !isEmailLogin.value}])
        }, null, 34),
        (isEmailLogin.value)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 2,
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              model: form,
              rules: _unref(rules)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "username",
                  style: {"margin-bottom":"17px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.username,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.username) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: _ctx.$t('login.email'),
                      name: "solarUsername",
                      type: "email",
                      autocomplete: "on",
                      clearable: "",
                      tabindex: "1",
                      onKeyup: _withKeys(enterUserName, ["enter"])
                    }, {
                      prefix: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onKeyup"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      visible: isShowBigChar.value,
                      placement: "right",
                      effect: "dark",
                      content: _unref(transformI18n)('login.capsLockTurnedOn')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          ref: "passwordInput",
                          modelValue: form.password,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.password) = $event)),
                          modelModifiers: { trim: true },
                          type: "password",
                          placeholder: _ctx.$t('login.password'),
                          name: "solarPassword",
                          autocomplete: "on",
                          onKeyup: _withKeys(handleLogin, ["enter"]),
                          clearable: "",
                          tabindex: "2",
                          onKeypress: passwordKeyPress
                        }, {
                          prefix: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "onKeyup"])
                      ]),
                      _: 1
                    }, 8, ["visible", "content"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "country" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.country,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.country) = $event)),
                      modelModifiers: { trim: true },
                      clearable: "",
                      filterable: "",
                      style: {"width":"100%"},
                      placeholder: _unref(transformI18n)('common.default'),
                      tabindex: "3"
                    }, {
                      prefix: _withCtx(() => [
                        _hoisted_16
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(defaultCountryObj), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.alpha2,
                            label: item.name,
                            value: item.alpha2
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: form.isRememberPwd,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.isRememberPwd) = $event)),
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('login.rememberPassword')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_router_link, {
                      to: "/forgot-password",
                      class: "passwordText forgotPassword"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('login.forgotPassword')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      loading: loading.value,
                      type: "primary",
                      class: "submitButton",
                      onClick: handleLogin
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('login.login')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      style: {"margin":"0 auto"},
                      to: "/create-account"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('login.createAccount')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true),
        (!isEmailLogin.value)
          ? (_openBlock(), _createBlock(_unref(ScanLogin), {
              key: 3,
              sysNameVal: sysNameVal.value,
              onEmailLogin: _cache[10] || (_cache[10] = ($event: any) => (isEmailLogin.value = true)),
              onLoginSuccess: loginSuccess
            }, null, 8, ["sysNameVal"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('login.copyRight', {year: _unref(nowYear), company: _unref(companyName)})), 1),
      _hoisted_21,
      _createElementVNode("a", {
        class: "copyRightText",
        href: _unref(termsOfUsePrivacyPolicyUrl),
        target: "_blank"
      }, _toDisplayString(_ctx.$t('login.termsOfUsePrivacyPolicy')), 9, _hoisted_22),
      (_unref(aboutUsUrl))
        ? (_openBlock(), _createElementBlock("span", _hoisted_23))
        : _createCommentVNode("", true),
      (_unref(aboutUsUrl))
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "copyRightText",
            href: _unref(aboutUsUrl),
            target: "_blank"
          }, _toDisplayString(_ctx.$t('login.aboutUs')), 9, _hoisted_24))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})